import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import {
    addData,
    deleteData,
    getAllData,
    getAllFilterData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import DeleteModel from "../../../components/DeleteModel";
import SearchIcon from '@mui/icons-material/Search';
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";



function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

const RedemptionClaims = () => {

    const [editData, setEditData] = useState({
    });
    const [createData, setCreateData] = useState(false);
    const [customerId, setCustomerId] = useState("");
    const [giftItem, setGiftItem] = useState("");
    const [claimDate, setClaimDate] = useState("");
    const [processDate, setProcessDate] = useState("");
    const [trackingCode, setTrackingCode] = useState("");
    const [status, setStatus] = useState(null);
    const [price, setPrice] = useState(null);
    const [giftCopy, setgiftCopy] = useState(null);
    const [termConditions, setTermConditions] = useState(null);


    const [pending, setPending] = useState(true);
    const [show, setShow] = useState(false);
    const [rows, setRows] = useState([

        // {
        //     "user_id": "123156465",
        //     "gift_item": "Test1",
        //     "claim_date": "2024-02-24 12:13	",
        //     "processed_date": "2024-02-24 12:13	",
        //     "tracking_number": "165461",
        //     "price": "165461",
        //     "status": "1"
        // },
        // {
        //     "user_id": "123525235",
        //     "gift_item": "Test2",
        //     "claim_date": "2024-02-24 12:13	",
        //     "processed_date": "2024-02-24 12:13	",
        //     "tracking_number": "165461",
        //     "price": "53534",
        //     "status": "1"
        // },
        // {
        //     "user_id": "2352525",
        //     "gift_item": "Test3",
        //     "claim_date": "2024-02-24 12:13	",
        //     "processed_date": "2024-02-24 12:13	",
        //     "tracking_number": "165461",
        //     "price": "34346346",
        //     "status": "2"
        // }

    ]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleClose = () => setShow(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        // api call
        redemptionClaimList();
    }, []);

    const redemptionClaimList = async () => {
        let url = `${endPoints.api.GET_REDEMPTIONCLAIM}`;
        setIsLoading(true);
        await getAllData(url)
            .then((response) => {
                setIsLoading(false);
                if (response.status === "success") {
                    setRows(response.data);
                    setPending(false);
                } else {
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error(error);
            });
    };

    const handleOk = () => {

        if (processDate && trackingCode && status && giftCopy && termConditions) {
            let url = editData?.id
                ? `${endPoints.api.UPDATE_REDEMPTIONCLAIM}`
                : null;

            let payload = {
                // user_id: customerId,
                // gift_item: giftItem,
                // claim_date: claimDate,
                tracking_number: trackingCode,
                status: status,
                processed_date: processDate,
                giftcopy: giftCopy,
                terms_condition: termConditions,
            };

            if (editData?.id) {
                payload.id = editData.id;
            }
            setIsLoading(true);
            addData(url, payload)
                .then((response) => {
                    setIsLoading(false);
                    if (response.data.status === "success") {
                        SuccesToast(response?.data?.message);
                        redemptionClaimList();
                        console.log(response);
                        handleClose();
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error(error);
                    ErrorToast(error);
                });
        }
        else {
            ErrorToast("all fields are required");
        }
    };

    useEffect(() => {
        if (editData) {
            setCustomerId(editData.user_id || '');
            setGiftItem(editData.gift_title || '');
            setClaimDate(editData.processed_date ? moment(editData.processed_date).format('YYYY-MM-DD') : '');
            setProcessDate(editData.processed_date ? moment.utc(editData.processed_date).format('YYYY-MM-DD') : '');
            setTrackingCode(editData.tracking_number || '');
            setStatus(editData.status || '');
            setPrice(editData.sagacoin_price || '');
            setgiftCopy(editData.giftcopy || '');
            setTermConditions(editData.terms_condition || '');

        }
    }, [editData]);





    // Redemption Filter 
    const [filteredRows, setFilteredRows] = useState(rows);
    const [filterValue, setFilterValue] = useState('');

    const handleFilterChange = (event) => {
        const newFilterValue = event.target.value.toLowerCase();
        setFilterValue(newFilterValue);

        if (newFilterValue === "") {
            setFilteredRows(rows);
        } else {
            const filteredData = rows.filter(item =>
                item.gift_item.toLowerCase().includes(newFilterValue)
            );
            setFilteredRows(filteredData);
        }
    };

    const rowsToDisplay = filterValue.length > 0 ? filteredRows : rows;


    return (
        <>
            <div className="main">
                <Toaster></Toaster>

                {isLoading && <Loader spinner={true} visible={isLoading} />}
                <div id="Sportbook" style={{ padding: "0px" }}>
                    <div className="container-fluid bg-color-sportbook custom-card4">
                        <div className="inner-space1">
                            <div className="row">

                                <div className="col-md-12" style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #444" }}>
                                    <h3 className="mb-2 heading-table" style={{ fontFamily: "ArticulatCF-Bold" }}>
                                        Redemption Claims
                                    </h3>

                                </div>
                            </div>

                            <div style={{ marginTop: "10px" }}>
                                <div className="table_search">
                                    <TextField
                                        style={{ marginBottom: '10px', width: '25%' }}
                                        placeholder="Enter gift title..."
                                        type="text"
                                        onChange={handleFilterChange}
                                        value={filterValue}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <TableContainer component={Paper}>
                                            <Table
                                                className="c_table"
                                                size="small"
                                                aria-label="a dense table"
                                                stickyHeader
                                                aria-label="sticky table"
                                                sx={{ minWidth: 500 }}
                                                aria-label="custom pagination table"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">Customer ID</TableCell>
                                                        <TableCell align="center">Gift Title</TableCell>
                                                        <TableCell align="center">Claim Date </TableCell>
                                                        <TableCell align="center">Processed Date</TableCell>
                                                        <TableCell align="center">Tracking Code</TableCell>
                                                        <TableCell align="center">Status</TableCell>
                                                        <TableCell align="center">Price</TableCell>
                                                        <TableCell align="center">Options</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {rowsToDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                                        <TableRow
                                                            key={row.id}
                                                            sx={{
                                                                "&:last-child td, &:last-child th": {
                                                                    border: 0,
                                                                },
                                                            }}
                                                        >
                                                            <TableCell align="center">{row.user_id}</TableCell>
                                                            <TableCell align="center">
                                                                {row.gift_title}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.processed_date ? moment.utc(row.processed_date).isValid() ? moment.utc(row.processed_date).format('YYYY-MM-DD') : '' : ''}

                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {/* {moment.utc(row.processed_date).format('YYYY-MM-DD')} */}
                                                                {row.processed_date ? moment.utc(row.processed_date).isValid() ? moment.utc(row.processed_date).format('YYYY-MM-DD') : '' : ''}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.tracking_number}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.status == 2 ? 'Delivered' : (row.status == 1 ? 'Pending' : '')}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.sagacoin_price}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <EditIcon onClick={() => {
                                                                    setShow(true);
                                                                    setCreateData(true);
                                                                    setEditData(row);
                                                                }} />

                                                            </TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={6} />
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[
                                                                5,
                                                                10,
                                                                25,
                                                                { label: "All", value: -1 },
                                                            ]}
                                                            colSpan={12}
                                                            count={rowsToDisplay.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            SelectProps={{
                                                                inputProps: {
                                                                    "aria-label": "rows per page",
                                                                },
                                                                native: true,
                                                            }}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                            ActionsComponent={TablePaginationActions}
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                    <>
                                        <Modal
                                            show={show}
                                            onHide={handleClose}
                                            // style={{ marginTop: "10%" }}
                                            size="lg"
                                            backdrop="static"
                                            keyboard={false}
                                        >
                                            <Modal.Header closeButton>
                                                <Modal.Title>Manage Redemption Claims:</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="row">

                                                    <div className="col-md-6">
                                                        <Form.Group
                                                            className="mb-3"
                                                            controlId="giftItem"
                                                        >
                                                            <Form.Label>Gift Title  </Form.Label>
                                                            <Form.Control type="text" placeholder="Gift Title " value={giftItem} onChange={(event) => {
                                                                setGiftItem(event.target.value);
                                                            }} disabled />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-6">
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3" controlId="game">
                                                            <Form.Label>
                                                                Price
                                                            </Form.Label>
                                                            <Form.Control type="text" placeholder=" Enter Price" value={price} onChange={(event) => {
                                                                setPrice(event.target.value);
                                                            }} disabled />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-6">
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3" controlId="game">
                                                            <Form.Label>
                                                                Claim Date
                                                            </Form.Label>
                                                            <Form.Control type="date" placeholder="Enter Claim Date" value={processDate} disabled />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-6">
                                                    </div>
                                                    <div className="col-md-4">
                                                        <Form.Group className="mb-3" controlId="game">
                                                            <Form.Label>
                                                                Tracking NO.
                                                            </Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Tracking NO." value={trackingCode} onChange={(event) => {
                                                                setTrackingCode(event.target.value);
                                                            }} />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <Form.Group
                                                            className="mb-3"
                                                            controlId="providerName"
                                                        >
                                                            <Form.Label>Status</Form.Label>
                                                            <Form.Select value={status} onChange={(event) => {
                                                                setStatus(event.target.value);
                                                            }} >
                                                                <option value='1'>Pending</option>
                                                                <option value='2'>Delivered</option>
                                                                {/* <option value='Sent'>Sent</option> */}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <Form.Group className="mb-3" controlId="game">
                                                            <Form.Label>
                                                                Process Date
                                                            </Form.Label>
                                                            <Form.Control type="date" placeholder="Process Date" value={processDate} onChange={(event) => {
                                                                setProcessDate(event.target.value);
                                                            }} />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <Form.Group className="mb-3" controlId="game">
                                                            <Form.Label>
                                                                Gift Copy :
                                                            </Form.Label>
                                                            <Form.Control as="textarea"
                                                                placeholder="Enter Gift Copy Here"
                                                                value={giftCopy} onChange={(event) => {
                                                                    setgiftCopy(event.target.value);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-4"></div>

                                                    <div className="col-md-8">
                                                        <Form.Group className="mb-3" controlId="game">
                                                            <Form.Label>
                                                                Terms and Conditions :
                                                            </Form.Label>
                                                            <Form.Control as="textarea"
                                                                placeholder="Enter Terms and Conditions Here"
                                                                value={termConditions} onChange={(event) => {
                                                                    setTermConditions(event.target.value);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </div>


                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button
                                                    onClick={handleOk}
                                                    style={{
                                                        background: "#04631e",
                                                        borderColor: "#04631e",
                                                    }}
                                                >
                                                    Update
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    marginTop: "20px",
                                }}
                            >

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RedemptionClaims;
